import { useCallback, useEffect, useState } from 'react'
import { UseI18n } from '../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { debounce, removeAccents } from '../../../../../../helpers/common'
import { CustomDropdown } from '../../../../common/customDropdown/index'
import { Input } from '../../../../common/input'
import { DropdownItem } from './DropdownItem'
import classes from './index.module.scss'

export const Dropdown = ({
  data = [],
  locationType,
  criteriaGroup,
  screeningIndicatorId,
}) => {
  const [keyword, setKeyword] = useState('')
  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [filteredData, setFilteredData] = useState(data)

  const onToggleShowDropdown = (isShow) => {
    setIsShowDropdown(isShow)
  }

  const handleSetFilteredData = (data, keyword) => {
    setFilteredData(
      data
        .filter((item) => {
          const formatItemName = removeAccents(item.name.toLowerCase())
          const formatKeyword = removeAccents(keyword.trim().toLowerCase())
          return formatItemName.includes(formatKeyword)
        })
        .slice(0, 200),
    )
  }

  const debounceSetFilteredData = useCallback(
    debounce(handleSetFilteredData, 300),
    [],
  )

  useEffect(() => {
    if (!isShowDropdown) {
      setKeyword('')
      handleSetFilteredData(data, keyword)
    }
  }, [data, isShowDropdown])

  useEffect(() => {
    debounceSetFilteredData(data, keyword)
  }, [keyword])

  const renderElement = ({ isShowDropdown }) => {
    return (
      <Element className={classes.select} style={{ borderColor: '#E0E0E0' }}>
        <Input
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          noControl
          placeholder={UseI18n(`screening.${locationType}`)}
          wrapperStyle={{ padding: '6px 12px', backgroundColor: '#FFFFFF' }}
          suffix={
            <Icon
              className={`${
                isShowDropdown ? 'icon-caret-top' : 'icon-caret-bottom'
              } pl1`}
              style={{ color: '#3A414B', fontSize: 8 }}
            />
          }
        />
      </Element>
    )
  }

  const renderDropdown = () => {
    return (
      <Element elementName="ul" className={classes.dropdownList}>
        {filteredData.map((item, index) => {
          return (
            <DropdownItem
              key={item.id}
              item={item}
              locationType={locationType}
              criteriaGroup={criteriaGroup}
              screeningIndicatorId={screeningIndicatorId}
            />
          )
        })}
      </Element>
    )
  }

  return (
    <Element className="flex1">
      <CustomDropdown
        renderElement={renderElement}
        renderDropdown={renderDropdown}
        onToggleShowDropdown={onToggleShowDropdown}
        dropdownItemHeight={28}
        dropdownStyle={{ backgroundColor: '#F3F3F3' }}
      />
    </Element>
  )
}
